export var ISearchSuggestionResponse;
(function (ISearchSuggestionResponse) {
    let ISearchRecommendation;
    (function (ISearchRecommendation) {
        /**
         * Return an instance of ISearchRecommendation with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ISearchRecommendation.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ISearchRecommendation = ISearchSuggestionResponse.ISearchRecommendation || (ISearchSuggestionResponse.ISearchRecommendation = {}));
    let ISearchQueryWithFilters;
    (function (ISearchQueryWithFilters) {
        /**
         * Return an instance of ISearchQueryWithFilters with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ISearchQueryWithFilters.build = (partial) => (Object.assign({ filters: [], filter_display_names: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ISearchQueryWithFilters = ISearchSuggestionResponse.ISearchQueryWithFilters || (ISearchSuggestionResponse.ISearchQueryWithFilters = {}));
    /**
     * Return an instance of ISearchSuggestionResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ISearchSuggestionResponse.build = (partial) => (Object.assign({ suggested_search_queries: {}, suggested_category_queries: {}, suggested_categories: [], suggested_brands: [], trending_searches: [], recently_viewed_products: [], top_search_results: [], recent_searches: [], suggested_search_queries_display_order: [], search_recommendations: [], suggested_apparel_categories: [], ordered_brands: [], recent_searches_with_filters: [], suggested_search_queries_with_filters: [], brands_you_may_know: [], suggested_navigations: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ISearchSuggestionResponse || (ISearchSuggestionResponse = {}));
